var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 213,
    viewBox: "0 0 213 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.5 205C161.379 205 206 160.938 206 106.5C206 52.1905 161.507 8 106.5 8C51.4929 8 7 52.0624 7 106.5C7 160.809 51.6211 205 106.5 205Z",
    fill: "#004137"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.698 114.874C112.698 114.874 146.481 107.452 146.481 61.129C146.481 60.4892 146.481 58.9536 146.353 58.4418C145.457 54.6029 141.618 53.5792 134.964 53.5792H79.5556C76.7404 53.5792 72.2617 53.1953 70.2143 56.0105C69.5744 56.9062 68.1668 57.4181 68.2948 59.0816C68.2948 59.3375 68.4228 60.3612 68.4228 60.6172C68.4228 106.684 102.717 114.874 102.717 114.874V148.912C102.717 148.912 87.3614 156.718 84.2903 158.638C80.9632 160.557 83.1386 163.5 84.5462 164.012C86.7216 164.908 92.0961 167.723 107.324 167.723C122.935 167.723 128.182 164.652 130.101 164.012C130.869 163.756 134.58 160.941 130.101 158.254C122.168 153.519 112.954 148.912 112.954 148.912V114.874H112.698Z",
    fill: "#CBD5DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.698 114.874C109.243 115.257 106.044 115.257 102.589 114.874V148.912C102.589 148.912 87.2332 156.718 84.1621 158.637C80.835 160.557 83.0104 163.5 84.418 164.012C86.5934 164.908 91.9679 167.723 107.196 167.723C122.807 167.723 128.054 164.652 129.973 164.012C130.741 163.756 134.452 160.941 129.973 158.253C122.039 153.519 112.826 148.912 112.826 148.912L112.698 114.874Z",
    fill: "#CBD5DC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M146.353 58.3137C146.353 63.8162 134.452 68.1669 107.324 68.1669C80.1956 68.1669 68.2949 63.6882 68.2949 58.3137C68.2949 52.8112 80.1956 48.4604 107.324 48.4604C134.324 48.4604 146.353 52.9392 146.353 58.3137Z",
    fill: "#CBD5DC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8781 56.3944C72.6459 66.5036 73.7976 73.7975 75.7171 81.7313C80.9636 102.461 92.9922 105.533 102.59 108.604C106.812 110.011 110.395 110.267 113.339 109.116C123.192 105.277 134.325 95.2955 140.339 78.1483C142.514 72.006 143.026 65.7358 143.666 57.6741C144.306 49.8682 71.1104 56.3944 71.1104 56.3944",
    fill: "#CBD5DC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0767 78.1484C75.0767 91.5847 87.8731 110.907 107.196 110.907C126.518 110.907 140.594 89.9211 140.594 78.2764C117.433 78.4044 75.0767 78.1484 75.0767 78.1484Z",
    fill: "#A01922"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M140.594 78.1485C140.594 81.3476 125.878 83.9069 107.835 83.9069C89.7925 83.9069 75.0767 81.3476 75.0767 78.1485C75.0767 74.9494 89.7925 72.3901 107.835 72.3901C125.878 72.3901 140.594 75.0774 140.594 78.1485Z",
    fill: "#A01922"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4272 81.4756C98.11 86.2103 117.689 86.2103 136.371 81.4756",
    stroke: "#BD1622",
    strokeWidth: 1.3832,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2378 60.873C94.5273 66.8874 119.096 66.8874 142.386 60.873",
    stroke: "#B1B1B1",
    strokeWidth: 1.5465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiver);
export default __webpack_public_path__ + "static/media/Liver.e2bd4a2de76ba6032160ef33f788bc5d.svg";
export { ForwardRef as ReactComponent };